import React from 'react'
import styled from 'styled-components'

import { Lounch } from 'components/lib/DesignSystem/Icons'

import NavigationItem from './NavigationItem'

function HelpMenu({
  className,
  setOnClickCallback,
  helpMenuItems,
  saveLastSeenProductRelease,
  onCloseCallback,
}) {
  const handleLinkClick = (url, name) => {
    if (name === 'Product Updates') saveLastSeenProductRelease()
    window.open(url, '_blank')
  }
  return (
    <NavigationItem
      className={className}
      setOnClickCallback={setOnClickCallback}
      onCloseCallback={onCloseCallback}
      width="344px"
      content={
        <>
          <div className="pc sb mb sml">What can we do for you?</div>
          {helpMenuItems.map((item) => (
            <div
              className="menu-item-container pc"
              onClick={() => handleLinkClick(item.url, item.name)}
              key={item.name}
            >
              <item.Icon className="mr dib-vac" width="24px" height="24px" />
              {item.name}
              {item.showRedIndication && <div className="red-indication dib-vac" />}
              <Lounch className="cp fr external-link" width="16px" height="16px" />
            </div>
          ))}
        </>
      }
    />
  )
}

export default styled(HelpMenu)`
  .content {
    padding: 22px 8px 8px 8px;
  }
  .menu-item-container {
    padding: 14px;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: #e6e9ee;
    }
    .red-indication {
      width: 10px;
      height: 10px;
      margin-left: 10px;
      border-radius: 5px;
      background: #e44258;
    }
    .external-link {
      position: relative;
      top: 4px;
    }
  }
`
